import './Contact.css';
import { ReactComponent as XIcon } from '../../images/icons/x-twitter-brands-solid-full.svg';

const socialIcons = {
  email: 'fa-solid fa-envelope',
  instagram: 'fa-brands fa-instagram',
  tiktok: 'fa-brands fa-tiktok',
  youtube: 'fa-brands fa-youtube',
};

function Contact({ content }) {
  return (
    <section className="section contact" id="contact">
      <div className="section__content contact__content">
        <p className="eyebrow">{content.eyebrow}</p>
        <p className="contact__title">{content.title}</p>
        <h2>{content.heading}</h2>
        <p className="contact__description">{content.description}</p>
        <ul className="contact__links">
          {content.socialLinks.map((link) => (
            <li key={link.label}>
              <a href={link.url} target={link.url.startsWith('http') ? '_blank' : undefined} rel={link.url.startsWith('http') ? 'noreferrer' : undefined}>
                {link.icon === 'x' ? (
                  <XIcon className="contact__x-icon" aria-hidden="true" />
                ) : (
                  <i className={socialIcons[link.icon]} aria-hidden="true" />
                )}
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default Contact;
